import { yupResolver } from '@hookform/resolvers/yup';
import classNames from 'classnames';
import { ENTITY_TYPES } from 'common';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { SortableHandle } from 'react-sortable-hoc';
import { useEditLearningCommunityVolumeNameMutation } from 'store/services/learningCommunities/volumeChapter';
import Form from 'style-guide/Form';
import { TextArea } from 'style-guide/Input';
import { message } from 'style-guide/ToastMessages';
import Text from 'style-guide/Typography/Text';
import { object, string } from 'yup';

const newVolumeNameSchema = object({
  newVolumeName: string()
    .trim()
    .min(3, 'Volume name must contain at least 3 characters')
    .max(180, 'Volume name must contain max 180 characters')
    .required(),
}).required();

const { MEMBER } = ENTITY_TYPES;

const VolumeDragHandle = SortableHandle(({ name, volumeId, id, setOpenKeys, isOpen, isPreview }) => {
  const [editVolumeName] = useEditLearningCommunityVolumeNameMutation();
  const { role } = useParams();

  const {
    handleSubmit,
    control,
    getValues,
    formState: { isValid, errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: { newVolumeName: name },
    resolver: yupResolver(newVolumeNameSchema),
  });

  const errorMessage = errors?.newVolumeName?.message;

  const handleErrorMessage = () => message.error(errorMessage);

  const handleRequest = (formData) => {
    if (formData.newVolumeName !== name) editVolumeName({ volumeId, id, ...formData });
  };

  const handleBlur = isValid ? handleSubmit(handleRequest) : handleErrorMessage;

  const formValue = getValues('newVolumeName');

  return (
    <div
      className={classNames({ pointer: !isOpen }, 'd-flex align-items-center volume-item-name')}
      onClick={() => (!isOpen ? setOpenKeys((items) => [...items, volumeId]) : null)}
    >
      {role !== MEMBER.short && isOpen && !isPreview ? (
        <Form onBlur={handleBlur}>
          <Controller
            name='newVolumeName'
            control={control}
            render={({ field }) => (
              <TextArea
                placeholder=''
                name='newVolumeName'
                autoSize={{ maxRows: 5 }}
                {...field}
                readOnly={!isOpen || role === MEMBER.short}
              />
            )}
          />
        </Form>
      ) : (
        <Text>{formValue}</Text>
      )}
    </div>
  );
});

export default VolumeDragHandle;
